import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_DOCTOR,
    UPDATE_DOCTOR,
    CREATE_DOCTOR, 
    DELETE_DOCTOR,
    FETCH_ALL_DOCTOR_NAMES,
    COPY_DOCTOR_TO_GEN2,
    FILTER_DOCTORS,
    UPDATE_EXCLUDE_DOCTORS_FOR_DOCTOR_REPORTS,
    UPDATE_DOCTOR_STATUS,
    UPDATE_DOCTOR_ACCOUNT_STATUS
} from 'constants/doctors.constants'
import {
    fetchDoctorsSuccess,
    updateDoctorSuccess,
    createDoctorSuccess,
    deleteDoctorSuccess,
    fetchDoctorNamesSuccess,
    copyDoctorToGen2Status,
    filterDoctorsSuccess,
    updateDoctorStatusSuccess,
} from "actions/doctors.action";
import { showErrors, stopLoader, setNotification } from "actions/general.action";
import axios from 'axios'
import { getDateInFormat, isValidUrl, cloundUrlGenerate } from "../util/commonFunc";


// doctor sagas

const fetchDoctorsRequest = async (page) => {
    return axios.get('/api/v1/super_admin/doctors?page=' + page);
}

function* fetchDoctors({ payload }) {
    try {
        const reuslt = yield call(fetchDoctorsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchDoctorsSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updateDoctorsRequest = async (payload) => {
    let fd = new FormData();
    fd.append('first_name', payload.first_name);
    fd.append('last_name', payload.last_name);
    fd.append('email', payload.email);
    fd.append('gender', payload.gender);
    fd.append('dob', payload.dob);
    fd.append('address', payload.address);
    fd.append('title', payload.title);
    fd.append('specialty', payload.specialty_id);
    fd.append('phone', payload.phone);
    fd.append('country', payload.country_id);
    fd.append('selected_langs', payload.selected_langs);
    fd.append('nic', payload.nic);
    if (payload.photo_profile_file != null) {
        fd.append('photo_profile', payload.photo_profile_file);
    }
    if (payload.photo_nic_file != null) {
        fd.append('photo_nic', payload.photo_nic_file);
    }
    if (payload.photo_signature_file != null) {
        fd.append('photo_signature', payload.photo_signature_file);
    }
    if (payload.photo_medical_licence_file != null) {
        fd.append('photo_medical_licence', payload.photo_medical_licence_file);
    }
    if (payload.photo_seal_file != null) {
        fd.append('photo_seal', payload.photo_seal_file);
    }
    fd.append('medical_school', payload.medical_school);
    fd.append('qualification', payload.qualification);
    fd.append('fee', payload.fee);
    fd.append('reg_no', payload.reg_no);
    fd.append('bank_acc_name', payload.bank_acc_name);
    fd.append('bank_accont_no', payload.bank_accont_no);
    fd.append('bank_name', payload.bank_name);
    fd.append('branch', payload.branch);
    if (payload.package_id != null) {
        fd.append('package_id', payload.package_id);
    }
    fd.append('is_on_demand', payload.is_on_demand);
    fd.append('registration_body', payload.registration_body);
    fd.append('practice_location', payload.practice_location);
    fd.append('consultation_duration', payload.consultation_duration);
    fd.append('pre_booking_text', payload.pre_booking_text);
    fd.append('is_insurance_policy', payload.is_insurance_policy);
    fd.append('medical_licence_exp', payload.medical_licence_exp);
    fd.append('comment', payload.comment);
    fd.append('status', payload.status);
    fd.append('is_portal', 0);
    fd.append('role_ids', 5);
    fd.append('average_wait_time', payload.average_wait_time);
    fd.append('max_appoinment', payload.max_appoinment);
    fd.append('appoinment_blocking_time', payload.appoinment_blocking_time);

    if (payload.availabilities) {
        Object.keys(payload.availabilities).forEach(availability => {

            payload.availabilities[availability].forEach(timeSlot => {
                fd.append(availability, (timeSlot.from + ' - ' + timeSlot.to));
            });
        })
    }

    return axios.put("api/v1/super_admin/doctors/" + payload.id, fd);
}

function* updateDoctor({ payload }) {
    try {
        const result = yield call(updateDoctorsRequest, payload);
        if (result.message) {
            yield put(showErrors(result.message));
        } else {
            yield all([
                put(updateDoctorSuccess(result.data)),
                put(stopLoader("Doctor Updated"))
            ])
        }
    } catch (error) {
        if (error.response.data.message != undefined) {
            yield put(showErrors(error.response.data.message));
        } else {
            yield put(showErrors(error.message));
        }
    }
}

const createDoctorsRequest = async (payload) => {
    let fd = new FormData();
    fd.append('first_name', payload.first_name);
    fd.append('last_name', payload.last_name);
    fd.append('email', payload.email);
    fd.append('gender', payload.gender);
    fd.append('dob', payload.dob);
    fd.append('address', payload.address);
    fd.append('title', payload.title);
    fd.append('specialty', payload.specialty_id);
    fd.append('phone', payload.phone);
    fd.append('country', payload.country_id);
    fd.append('selected_langs', payload.selected_langs);
    fd.append('nic', payload.nic);
    fd.append('photo_profile', payload.photo_profile_file);
    fd.append('photo_nic', payload.photo_nic_file);
    fd.append('photo_signature', payload.photo_signature_file);
    fd.append('photo_medical_licence', payload.photo_medical_licence_file);
    fd.append('medical_school', payload.medical_school);
    fd.append('qualification', payload.qualification);
    fd.append('fee', payload.fee);
    fd.append('reg_no', payload.reg_no);
    fd.append('bank_acc_name', payload.bank_acc_name);
    fd.append('bank_accont_no', payload.bank_accont_no);
    fd.append('bank_name', payload.bank_name);
    fd.append('branch', payload.branch);
    fd.append('package_id', payload.package_id);
    fd.append('is_on_demand', payload.is_on_demand);
    fd.append('registration_body', payload.registration_body);
    fd.append('practice_location', payload.practice_location);
    fd.append('consultation_duration', payload.consultation_duration);
    fd.append('pre_booking_text', payload.pre_booking_text);
    fd.append('is_insurance_policy', payload.is_insurance_policy);
    fd.append('medical_licence_exp', payload.medical_licence_exp);
    fd.append('comment', payload.comment);
    fd.append('status', payload.status);
    fd.append('is_portal', 0);
    fd.append('role_ids', 5);
    fd.append('average_wait_time', payload.average_wait_time);
    fd.append('photo_seal', payload.photo_seal_file);
    fd.append('max_appoinment', payload.max_appoinment);
    fd.append('appoinment_blocking_time', payload.appoinment_blocking_time);

    if (payload.availabilities) {
        Object.keys(payload.availabilities).forEach(availability => {

            payload.availabilities[availability].forEach(timeSlot => {
                fd.append(availability, (timeSlot.from + ' - ' + timeSlot.to));
            });
        })
    }

    return axios.post("api/v1/super_admin/doctors", fd)
}

function* createDoctor({ payload }) {
    try {
        const result = yield call(createDoctorsRequest, payload);
        if (result.message) {
            yield put(showErrors(result.message));
        } else {
            yield all([
                put(createDoctorSuccess(result.data)),
                put(stopLoader("Doctor created"))
            ])
        }
    } catch (error) {
        if (error.response.data.message != undefined) {
            yield put(showErrors(error.response.data.message));
        } else {
            yield put(showErrors(error.message));
        }
    }
}

const deleteDoctorsRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/doctors/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteDoctor({ payload }) {
    try {
        const reuslt = yield call(deleteDoctorsRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteDoctorSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const fetchDoctorNamesRequest = async (payload) => {
    return axios.request({
        method: 'GET',
        url: `/api/v1/super_admin/doctor_list`,
        params: payload
    })
}

function* fetchDoctorNames({ payload }) {
    try {
        const reuslt = yield call(fetchDoctorNamesRequest, payload);

        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchDoctorNamesSuccess({
                ...reuslt.data,
                isFetched: !payload
            }));
        }

    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const getUrl = (url) => {
    if (url) {
        if (isValidUrl(url)) {
            return url;
        } else {
            return cloundUrlGenerate(process.env.REACT_APP_AWS_GENERAL_BUCKET, process.env.REACT_APP_AWS_GENERAL_BUCKET_DOCTOR_ENTITY + "/" + url);
        }
    }
}

const copyDoctorToGn2Request = async (payload) => {
  // set data object
  const {
    id,
    title,
    first_name,
    last_name,
    specialty,
    phone,
    email,
    fee,
    medical_school,
    qualification,
    registration_body,
    pre_booking_text,
    consultation_duration,
    reg_no,
    dob,
    languages,
    address,
    practice_location,
    nic,
    average_wait_time,
    photo_profile,
    photo_signature,
    photo_seal,
  } = payload;

  // object validation
  if (
    id !== "" && id !== null &&
    title !== "" && title !== null &&
    first_name !== "" && first_name !== null &&
    last_name !== "" && last_name !== null &&
    Object.keys(specialty).length !== 0 &&
    phone !== "" && phone !== null &&
    email !== "" && email !== null &&
    fee !== "" && fee !== null &&
    medical_school !== "" && medical_school !== null &&
    qualification !== "" && qualification !== null &&
    registration_body !== "" && registration_body !== null &&
    reg_no !== "" && reg_no !== null &&
    languages.length > 0 &&
    practice_location !== "" && practice_location !== null &&
    nic !== "" && nic !== null &&
    dob !== "" &&  dob !== null &&
    address !== "" &&  address !== null &&
    average_wait_time !== "" &&  average_wait_time !== null &&
    pre_booking_text !== "" &&  pre_booking_text !== null &&
    consultation_duration !== "" &&  consultation_duration !== null &&
    photo_profile !== "" &&  photo_profile !== null &&
    photo_signature !== "" &&  photo_signature !== null &&
    photo_seal !== "" &&  photo_seal !== null 
  ) {
    var phone_pattern_expression = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    let phone_is_valid = phone_pattern_expression.test(phone);
    if (phone_is_valid) {
      let language_name_array = [];
      languages.map((language) => language_name_array.push(language.name.toLowerCase()));
      const data_object = {
        isArray: false,
        data: {
          id: id,
          title: title,
          firstName: first_name,
          lastName: last_name,
          type: "video",
          speciality: specialty.name,
          phoneNumber: phone,
          email: email,
          odocFee: 1000,
          doctorFee: parseInt(fee),
          education: medical_school, // medical_school
          qualification: qualification,
          registration: {
            body: registration_body,
            number: reg_no.toString(),
          },
          dateOfBirth: getDateInFormat(dob), // dob have to convert
          languages: language_name_array,
          searchTags: [""],
          address: address,
          practiceLocations: [practice_location],
          nic: nic,
          pictureUrl: getUrl(photo_profile),
          signatureUrl: getUrl(photo_signature),
          sealUrl: getUrl(photo_seal),
          regionDomainId: 2,
          autoInsertToDomains: false,
          notes: pre_booking_text,
          averageWaitTime: parseInt(average_wait_time),
          selectConsultationTimeInMinutes: consultation_duration,
          optInToCorporateBookings: false,
          corporateDoctorFee: 12,
        },
      };
      
        return axios.post(
            process.env.REACT_APP_GEN2_BACKEND_HOST + '/dashboard/v1/consultants', 
            data_object, 
            {
                headers: {
                    Authorization: "Bearer " + process.env.REACT_APP_GEN2_SECRET_KEY,
                },
            }
        );
    }
    return { error: { message: "Phone Number Format Incorrect" } };
  } else {
    return { error: { message: "Doctor's Data Not Complete" } };
  }
};

function* copyDoctorToGn2({ payload }) {
  try {
    const result = yield call(copyDoctorToGn2Request, payload);
    if (result.error) {
      yield put(
        copyDoctorToGen2Status({
          open: true,
          status: "error",
          message: "Copy to Gn2 Doctor Failed !\n" + result.error.message,
        })
      );
    } else {
      yield put(
        copyDoctorToGen2Status({
          open: true,
          status: "success",
          message: "Copy to Gn2 Doctor Success !",
        })
      );
    }
  } catch (error) {
    yield put(
      copyDoctorToGen2Status({
        open: true,
        status: "error",
        message: "Copy to Gn2 Doctor Failed !\n" + error.response.data.error.message.toLowerCase(),
      })
    );
  }
}

const filterDoctorsRequest = async (payload) => {
    let link = '/api/v1/super_admin/doctors?key=' + payload.key + '&value=' + payload.value + "&page=" + payload.page;
    return axios.get(link);
  };

function* filterDoctors({ payload }) {
    try {
      const result = yield call(filterDoctorsRequest, payload);
  
      if (result.message) {
        yield put(showErrors(result.message));
      } else {
        yield put(filterDoctorsSuccess(result.data));
        yield put(stopLoader());
      }
    } catch (error) {
      yield put(showErrors(error.message));
    }
  }

//   updateExcludeDoctorsForDR
const updateExcludeDoctorsForDRRequest = async (payload) => {
    return axios.put('/api/v1/super_admin/doctors/update_periodic_doctors_report_status', payload);
}

function* updateExcludeDoctorsForDR({ payload }) {
    let notification = {
        open: true,
        status: "",
        message: "",
    }
    try {
        const result = yield call(updateExcludeDoctorsForDRRequest, payload);
        if (result.data.message) {
            if(result.data.message === "Doctor List Updated") {
                notification.status = "success";
                notification.message = "Update Exclude Doctors For Doctor Reports Success";
                const result_update_doctor_list = yield call(fetchDoctorNamesRequest, null);
                if (result_update_doctor_list.message) {
                    notification.status = "error";
                    notification.message = result_update_doctor_list.message;
                    yield put(stopLoader());
                    yield put(setNotification(notification));
                } else {
                    yield put(fetchDoctorNamesSuccess({
                        ...result_update_doctor_list.data,
                        isFetched: true
                    }));
                    yield put(stopLoader());
                    yield put(setNotification(notification));
                }
            }else {
                notification.status = "error";
                notification.message = result.message;
                yield put(stopLoader());
                yield put(setNotification(notification));
            }
           
        } else {
            notification.status = result.data.data.alert ? "warning" : "success";
            notification.message = result.data.data.alert || "Data View Success";
            if(notification.message === "Data View Success") {
                notification.open = false;
                // yield put(viewDoctorReportsSuccess(result.data));
            }
            yield put(stopLoader());
            yield put(setNotification(notification));
        }
    } catch (error) {
        notification.status = "error";
        notification.message = error;
        yield put(stopLoader());
        yield put(setNotification(notification));
    };
}  

const updateDoctorStatusRequest = async (payload) => {
    return axios.put("api/v1/super_admin/doctor_status/" + payload.id, {
        is_online: payload.status
    });
}

function* updateDoctorStatus({ payload }) {
    let notification = {
        open: true,
        status: "",
        message: "",
      }
    try {
        const result = yield call(updateDoctorStatusRequest, payload);
        if (result.message) {
            notification.status = "error";
            notification.message = "Request Failed";
            yield put(stopLoader());
        } else {
            notification.status = "success";
            notification.message = "Doctor Online Status Updated";
            yield all([
                put(updateDoctorStatusSuccess(result.data)),
                put(stopLoader(notification.message))
            ]);
        }
        yield put(setNotification(notification));
    } catch (error) {
        notification.status = "error";
        notification.message = error.message;
        yield put(stopLoader());
        yield put(setNotification(notification));
    }
}

// have to change according to saman update
const updateDoctorAccountStatusRequest = async (payload) => {
    return axios.put("api/v1/super_admin/doctor_account_status_update/" + payload.id, payload.query);
}

function* updateDoctorAccountStatus({ payload }) {
    let notification = {
        open: true,
        status: "",
        message: "",
      }
    try {
        const result = yield call(updateDoctorAccountStatusRequest, payload);
        if (result.message) {
            notification.status = "error";
            notification.message = "Request Failed";
            yield put(stopLoader());
        } else {
            notification.status = "success";
            notification.message = "Doctor Account Status Updated";
            yield all([
                put(updateDoctorStatusSuccess(result.data)),
                put(stopLoader(notification.message))
            ]);
        }
        yield put(setNotification(notification));
    } catch (error) {
        notification.status = "error";
        notification.message = error.message;
        yield put(stopLoader());
        yield put(setNotification(notification));
    }
}

// fork doctor
export function* forkFetchDoctors() {
    yield takeEvery(FETCH_ALL_DOCTOR, fetchDoctors);
}

export function* forkUpdateDoctor() {
    yield takeEvery(UPDATE_DOCTOR, updateDoctor);
}

export function* forkCreateDoctor() {
    yield takeEvery(CREATE_DOCTOR, createDoctor);
}

export function* forkDeleteDoctor() {
    yield takeEvery(DELETE_DOCTOR, deleteDoctor);
}

export function* forkFetchDoctorNames() {
    yield takeEvery(FETCH_ALL_DOCTOR_NAMES, fetchDoctorNames);
}

export function* forkCopyDoctorToGn2() {
  yield takeEvery(COPY_DOCTOR_TO_GEN2, copyDoctorToGn2);
}

export function* forkFilterDoctor() {
    yield takeEvery(FILTER_DOCTORS, filterDoctors);
}

export function* forkUpdateExcludeDoctorsForDR() {
    yield takeEvery(UPDATE_EXCLUDE_DOCTORS_FOR_DOCTOR_REPORTS, updateExcludeDoctorsForDR);
}

export function* forkUpdateDoctorStatus() {
    yield takeEvery(UPDATE_DOCTOR_STATUS, updateDoctorStatus);
}

export function* forkUpdateDoctorAccountStatus() {
    yield takeEvery(UPDATE_DOCTOR_ACCOUNT_STATUS, updateDoctorAccountStatus);
}

export default function* rootSaga() {
    yield all([
        fork(forkFetchDoctors),
        fork(forkUpdateDoctor),
        fork(forkCreateDoctor),
        fork(forkDeleteDoctor),
        fork(forkFetchDoctorNames),
        fork(forkCopyDoctorToGn2),
        fork(forkFilterDoctor),
        fork(forkUpdateExcludeDoctorsForDR),
        fork(forkUpdateDoctorStatus),
        fork(forkUpdateDoctorAccountStatus),
    ]);
}